import data from "../assets/data/DailyMenu";



export const useWeeklyRestaurantMenu = () => {
    return data;
}